<div class="alerts" [style.z-index]="modifyZIndex ? 0 : 95">
  <div
    class="alert"
    [@alert]="''"
    *ngFor="let alert of alerts.slice(0, 4)"
    [ngClass]="alert.type"
    (mouseenter)="mouseEnter(alert.id)"
    (mouseleave)="mouseLeave()"
  >
    <div class="text">
      {{ text }}
      <span [class.text--clickable]="alert.click" (click)="alert.click && alert.click()">
        {{ clickableText }}
      </span>
    </div>
    <div class="icon" (click)="onCloseClick(alert.id)">
      <span class="cmx-icon-close" aria-hidden="true"></span>
    </div>
  </div>
</div>
